import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { deleteCreditCard } from '../../../../redux/slices/billingSlice/billingSlice';

function DeletePaymentMethodConfirmationModal({
  show,
  handleClose,
  servicePlanId,
}) {
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      await dispatch(deleteCreditCard({ subscriptionId: servicePlanId })).unwrap();
      handleClose();
      window.location.reload();
    } catch (e) {
      setError('Something went wrong. Please try again.');
      setSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="md" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Delete Payment Method</Modal.Title>
      </Modal.Header>

      <Modal.Body className="text-center px-4">

        {error && (
        <div className="alert alert-danger text-center mb-4">
          {error}
        </div>
        )}
        <p>
          <strong>This will remove your credit card as a payment method.</strong>
          {' '}
          If you do not have a credit card at the time of renewal, your service will end.
          You may contact our team to make alternative payment arrangements.

        </p>

      </Modal.Body>

      <Modal.Footer className="justify-content-center">

        <button
          type="button"
          className="btn btn-primary"
          onClick={handleSubmit}
          disabled={submitting}
        >
          Remove Card
        </button>

        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={handleClose}
        >
          Cancel
        </button>
      </Modal.Footer>
    </Modal>
  );
}

DeletePaymentMethodConfirmationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  servicePlanId: PropTypes.string.isRequired,
};

export default DeletePaymentMethodConfirmationModal;
